// extracted by mini-css-extract-plugin
export default {"dropzone":"SelectCsvDialog_dropzone__MX2Ic"};